module.exports = __webpack_public_path__ + "static/media/giroflex.59859535.png";